import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppBackbtnEventData } from "../redux/common";

export default function useAppBackBtn() {
  const dispatch = useDispatch();

  const appBackBtnEventData = useSelector((state => state.common.appBackBtnEventData));

  const setBackEventData = useCallback(({ pathname, state, eventFunc }) => {
    dispatch(setAppBackbtnEventData({ pathname, state, eventFunc }));
  }, []);

  const initBackEventData = useCallback(() => {
    dispatch(setAppBackbtnEventData({ pathname: '', state: null, eventFunc: null, isPush: false }))
  }, [])


  return {
    appBackBtnEventData,
    setBackEventData,
    initBackEventData
  }
}